import React from 'react';

const PageTitleSearch = () => {
    return (
        <section id="page-title">
            <div className="wrapper">
                <div className="title">
                    <h1>Search results for: The</h1>
                </div>
            </div>
        </section>
    );
};

export default PageTitleSearch;
